const backendURL = import.meta.env.VITE_API_URL;
import { tryRefreshToken } from "./auth";

export async function fetchWithAuth(endpoint, options = {}) {
  const url = backendURL + endpoint;
  let token = localStorage.getItem('accessToken');

  if (!token) {
    // No token, simplemente lanza error
    throw new Error('No access token found');
  }

  // Construir headers con Authorization
  options.headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
    credentials: 'include', // Asegúrate de incluir las cookies
  };

  let response = await fetch(url, options);
  if (response.status === 401) {
    // Intentar refrescar token
    const newToken = await tryRefreshToken();
    if (!newToken) {
      window.location.href = '/unauthorized'; // Redirige a Unauthorized si no se puede refrescar
      // Si no se puede refrescar, lanza error para que el caller lo maneje
      throw new Error('Unauthorized');
    }

    // Actualiza token y headers con el nuevo token
    token = newToken;
    options.headers.Authorization = `Bearer ${token}`;

    // Reintenta la llamada con el nuevo token
    response = await fetch(url, options);
    if (response.status === 401) {
      window.location.href = '/unauthorized'; // Redirige a Unauthorized si sigue sin autorización
      // Si sigue 401, lanza error
      throw new Error('Unauthorized');
    }
  }

  return response;
}
